import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class SuccessIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fillRule="evenodd" d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.284-12l-4.59 4.73-2.127-1.837L3 8.693l2.985 2.571.858.736.784-.81L13 5.65 11.284 4z"/></svg>
        )
    }
}

export default withCssClassName(SuccessIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/success-icon.js